module.exports = __webpack_public_path__ + "static/img/solutionBanner.4fa77a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solutionBanner.png
// module id = nOGH
// module chunks = 2